import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Typography from 'material-ui/Typography'

import {confirmEmail} from '../text'
import Container from '../../../common/components/Container'
import HeaderProgress from '../../../common/components/HeaderProgress'
import styles from '../styles'

class ConfirmEmail extends React.Component {

  renderMessage = message => (
    <Container>
      <div className={this.props.classes.messageWrapper}>
        <Typography variant="display2" gutterBottom>{message}</Typography>
      </div>
    </Container>
  )

  render() {
    const {isSaving, error} = this.props
    if (isSaving === true) return <HeaderProgress show={true}/>
    if (error !== '') return this.renderMessage(error)
    return this.renderMessage(confirmEmail.success)
  }
}

ConfirmEmail.propTypes = {
  isSaving: PropTypes.bool,
  error: PropTypes.string,
}

export default withStyles(styles)(ConfirmEmail)



// WEBPACK FOOTER //
// ./src/sections/confirmEmail/components/ConfirmEmail.js